export const ASSETS = {
  logos: {
    title: {
      path: 'assets/title.png',
      width: 200,
      height: 80
    },
    playStore: {
      path: 'assets/play_store.png',
      width: 120,
      height: 50
    },
    appStore: {
      path: 'assets/app_store.svg',
      width: 120,
      height: 50
    }
  },
  backgrounds: {
    boxArt: {
      path: 'assets/backgrounds/box_art.png',
      width: 390,
      height: 844
    },
    background: {
      path: 'assets/backgrounds/background.png',
      width: 390,
      height: 844
    },
    winter: {
      path: 'assets/backgrounds/winter.png',
      width: 1920,
      height: 1080
    },
    matchmaking_panel: {
      path: 'assets/backgrounds/matchmaking_panel.png',
      width: 366,
      height: 436
    },
    matchmaking_background: {
      path: 'assets/backgrounds/matchmaking_background.png',
      width: 1797,
      height: 1198
    },
    lobby_background: {
      path: 'assets/backgrounds/lobby_background.png',
      width: 1797,
      height: 1198
    },
    lobby_join_section: {
      path: 'assets/backgrounds/lobby_join_section.png',
      width: 374,
      height: 271
    },
    lobby_players_panel: {
      path: 'assets/backgrounds/lobby_players_panel.png',
      width: 348,
      height: 292
    }
  },
  ui: {
    titleBanner: {
      path: 'assets/ui/title_banner.png',
      width: 390,
      height: 120
    },
    hudBackground: {
      path: 'assets/ui/hud_background.png',
      width: 390,
      height: 97
    },
    verticalDivider: {
      path: 'assets/ui/vertical_divider.png',
      width: 1,
      height: 32
    },
    timerBackground: {
      path: 'assets/ui/timer_background.png',
      width: 50,
      height: 50
    },
    meterBackground: {
      path: 'assets/ui/meter_background.png',
      width: 112,
      height: 10
    },
    button: {
      path: 'assets/ui/button.png',
      width: 100,
      height: 50
    },
    eat: {
      path: 'assets/ui/eat.png',
      width: 32,
      height: 32
    },
    fire: {
      path: 'assets/ui/fire.png',
      width: 32,
      height: 32
    },
    popup: {
      path: 'assets/ui/popup.png',
      width: 300,
      height: 187
    },
    play_button: {
      path: 'assets/ui/play_button.png',
      width: 215,
      height: 80
    },
    lobby_button: {
      path: 'assets/ui/lobby_button.png',
      width: 128,
      height: 55
    },
    button_background: {
      path: 'assets/ui/button_background.png',
      width: 128,
      height: 55
    }
  },
  characters: {
    player: {
      path: 'assets/characters/player.png',
      width: 40,
      height: 40
    }
  },
  environment: {
    tree: {
      path: 'assets/environment/tree.png',
      width: 40,
      height: 40
    },
    bush: {
      path: 'assets/environment/bush.png',
      width: 40,
      height: 40
    }
  },
  items: {
    fruit: {
      path: 'assets/items/fruit.png',
      width: 20,
      height: 20
    },
    wood: {
      path: 'assets/items/wood.png',
      width: 20,
      height: 20
    },
    snowflake: {
      path: 'assets/items/snowflake.png',
      width: 20,
      height: 20
    },
    hunger: {
      path: 'assets/items/hunger.png',
      width: 20,
      height: 20
    }
  }
};
